import Vue from 'vue';
import { toYuan } from '../../utils/unit-conversion';
export default Vue.extend({
    name: 'login',
    components: {},
    props: {
        info: {
            required: true,
            type: Array,
            default: function () {
                return [];
            },
        },
        operation: {
            required: true,
            type: Boolean,
            default: function () {
                return true;
            },
        },
        inforQuery: {
            required: true,
            type: String,
            default: function () {
                return '';
            },
        },
        infoText: {
            required: true,
            type: String,
            default: function () {
                return '';
            },
        },
    },
    created: function () {
        this.query = JSON.parse(this.inforQuery);
    },
    mounted: function () {
        this.getPolicyInfo();
    },
    computed: {
        // ...mapState('info', {
        //   cityList: 'cityList'
        // })
        totalActualAmount: function () {
            var totalActualAmount = 0;
            this.tableData.forEach(function (item) {
                item.showStatus === 'LENT' && (totalActualAmount += item.lentAmount);
            });
            return toYuan(totalActualAmount).toFixed(2);
        },
    },
    watch: {
    // cityList: function (val) {
    //   this.filterConfig[5].options = val
    // }
    },
    data: function () {
        return {
            statusForName: {
                APPLIED: '审核中',
                AUDIT_PASS: '放款中',
                LENT: '已放款',
                REPAID: '已还款',
                AUDIT_REFUSED: '审核未通过',
            },
            statusForNameTitle: {
                APPLIED: '申请审核中',
                AUDIT_PASS: '申请已通过，放款中',
                LENT: '恭喜您！已放款',
                REPAID: '已还款',
                AUDIT_REFUSED: '抱歉！审核未通过',
            },
            query: {},
            tableData: [],
            currentPage: 1,
            currentPageSize: 5,
            totalItems: 30,
            headerStyle: function (_a) {
                var row = _a.row, rowIndex = _a.rowIndex;
                return 'background:#F4F5F7;font-family: PingFangSC-Regular;font-size: 14px;color: #666F83;letter-spacing: 0;line-height: 48px;height:48px;';
            },
            cellStyle: function (_a) {
                var row = _a.row, column = _a.column, rowIndex = _a.rowIndex, columnIndex = _a.columnIndex;
                if (columnIndex === 0) {
                    return 'width:350px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap';
                }
                if (row.showStatus === 'AUDIT_REFUSED' &&
                    column.property === 'showStatus') {
                    return 'color:#FF5257;';
                }
            },
        };
    },
    methods: {
        getPolicyInfo: function () {
            var _this = this;
            this.$request({
                method: 'post',
                url: '/proxy/api/application/policy/list',
                data: {
                    applicationCode: this.query.applicationCode,
                },
            }).then(function (res) {
                if (!res)
                    return;
                if (res && !res.errorCode) {
                    _this.tableData = res.data;
                }
            });
        },
        toYuanFormatter: function (row, column, cellValue, index) {
            return cellValue == 0 ? '--' : toYuan(cellValue).toFixed(2);
        },
    },
});
